import { mapGetters, mapActions, mapState } from 'vuex'

import brandingMixin from '@/mixins/branding'
import deviceMixin from '@/shared/mixins/device'
import Menu from '@/components/menu/menu.vue'
import Logo from '@/components/logo/logo.vue'
import AgentSticker from '@/components/agentSticker/agentSticker.vue'
import Icon from '@/components/icon'

export default {
  mixins: [brandingMixin, deviceMixin],
  components: {
    appMenu: Menu,
    appLogo: Logo,
    appAgentSticker: AgentSticker,
    appIcon: Icon
  },
  data () {
    return {
      isScrolling: false,
      isMuted: false
    }
  },
  computed: {
    ...mapState('tours', ['multiAgents', 'settings']),
    ...mapState('utils', ['fullStickyBg']),
    ...mapGetters('tours', ['getThemeName']),
    isLogoInvert() {
      return this.getThemeName === 'dark'
    },
    videoIsOn () {
			return this.fullStickyBg.isPlay
		},
    isIdle () {
			return this.$store.state.idleVue.isIdle;
		}
  },
  methods: {
    ...mapActions('utils', ['setVisibleMobileMenu', 'setScrollOffset']),
    checkScrollTop () {
      if (document.querySelector('html').scrollTop > 0) {
        this.isScrolling = true
      } else {
        this.isScrolling = false
      }
    },
    resizingStart () {
      let resizing

      window.addEventListener('resize', () => {
          clearTimeout(resizing)
          resizing = setTimeout(this.setScrollOffsetHeight, 500)
      })
    },
    setScrollOffsetHeight () {
      const scrollOffset = this.$refs.headerContainer
        ? -this.$refs.headerContainer.offsetHeight
        : 0

      this.setScrollOffset(scrollOffset)
    },
    showMobileMenu () {
      this.setVisibleMobileMenu(true)
    },
    setMuted () {
      this.isMuted = true
      this.$refs.audio.volume = 0
      localStorage.setItem('music_muted', '1')
    },
    setUnmuted () {
      this.isMuted = false
      this.$refs.audio.volume = 0.2
      localStorage.setItem('music_muted', '0')
    },
    togglePlay () {
      if (this.$refs.audio.paused) {
        this.$refs.audio.play()
        this.setUnmuted()
        return
      }

      if (this.$refs.audio.volume > 0) {
        this.setMuted()
      } else {
        this.setUnmuted()
      }
    }
  },
  mounted () {
    this.setScrollOffsetHeight()
    this.resizingStart()

    window.addEventListener('scroll', this.checkScrollTop)

    if (!this.settings.music) {
      return
    }

    this.$refs.audio.oncanplaythrough = () => {
      if (this.$refs.audio.paused) {
        this.setMuted()
        return
      }

      if (localStorage.getItem('music_muted') === '1') {
        this.setMuted()
      } else {
        this.setUnmuted()
      }
    };
  },
  watch: {
    videoIsOn () {
			if (this.videoIsOn && this.settings.music) {
        this.setMuted()
			}
    }
  }
}
